/**************************************************************************
 * PRODUCT QUANTITY FUNCTIONS
 **************************************************************************/

$(function () {
    _initQtyIncrementer();
});

function _initQtyIncrementer() {
    _bindIncrementEventListener();
    updateQtyIncrementerButtonsState();
}

function updateQtyIncrementerButtonsState() {
    $('.item-addToCart').each(function () {
        updateQuantityButtonsState($(this));
    });
}

function _bindIncrementEventListener() {
    $(document).on('click', '.plus-addToCart, .minus-addToCart', function (event) {
        _incrementClickEvent(event);
    });
}

function updateQuantityButtonsState(product, newlyAdded = false) {
    var min = +(product.data('min-qty'));
    var max = +(product.data('max-qty'));
    var inc = +(product.data('unit-increment'));
    var qty = +(product.find('.qty-addToCart').first().text());
    var minus = product.find('.minus-addToCart');
    var plus = product.find('.plus-addToCart');
    var deletable = product.data('product-deletable');
    var minAllowed = deletable ? min - inc : min;

    if (!product.data('is-inactive') && minus.length && plus.length) {
        let productTileType = product.data('tile-type');

        if (productTileType !== 'mini-cart') {
            minus.prop('disabled', ((qty - inc) < minAllowed) || newlyAdded);
            if (minus.hasClass('isGenius')  && qty === 1 && minus.prop('disabled')) {
                minus.prop('disabled', false);
            }
        }

        if (!plus.hasClass('isGenius') && !plus.hasClass('notEligible')) {
            plus.prop('disabled', ((qty + inc) > max) || newlyAdded);
        }

        if ((qty <= min && !minus.hasClass('isGenius')) || minus.hasClass('notEligible')) {
            minus.removeClass('multiple-in-cart');
            minus.addClass('lastInCart');
        } else {
            minus.addClass('multiple-in-cart');
            minus.removeClass('lastInCart');
        }
        if ((qty - inc) >= min) {
            minus.find('span').text(minusOpen);
        } else {
            minus.find('span').text(minusLimit);
        }
        if ((qty + inc) <= max) {
            plus.find('span').text(plusOpen);
        } else {
            plus.find('span').text(plusLimit);
        }
    }
}

function _incrementClickEvent(event) {
    var product = $(event.target).closest('.item-addToCart');
    var unitIncrement = +(product.data('unit-increment'));
    var minQty = +(product.data('min-qty'));
    var maxQty = +(product.data('max-qty'));
    var plusTriggered = $(event.target).is('.plus-addToCart');
    var currentValue = +(product.find('.qty-addToCart').first().text());
    var deletable = product.data('product-deletable');
    var minAllowed = deletable ? minQty - unitIncrement : minQty;
    // Lire le cartEntryNumber dans le HTML plutot que depuis les data-* pour eviter un probleme avec les produits avec options (dropdown)
    var cartEntryNumber = product.attr('data-cart-entry');
    var productSku = product.data('product-code');
    var impulsiveProductSidePanel = $('.mini-cart-spontaneous-purchase .product-tile-spontaneous-purchase');
    var isFav = $(event.target).closest('.products-favourite--grid').length > 0;

    if (impulsiveProductSidePanel.length > 0 && typeof cartEntryNumber === 'undefined' || isFav) {
        productTiles = $(`div[data-product-code="${productSku}"]`);
    } else {
        productTiles = $(`div[data-product-code="${productSku}"][data-cart-entry="${cartEntryNumber}"]`);
    }

    var newValue;
    var productStarter = false;
    if (plusTriggered) {
        if (currentValue == 0) {
            newValue = minQty;
            productStarter = true;
        } else {
            newValue = currentValue + unitIncrement;
        }

        if (newValue <= maxQty) {
            productTiles.find('.qty-addToCart').text(newValue);
            updateQuantityButtonsState(product, productStarter);
        }
    } else {
        newValue = currentValue - unitIncrement;
        if (newValue >= minAllowed) {
            productTiles.find('.qty-addToCart').text(newValue);
            updateQuantityButtonsState(product, productStarter);
        }
    }
}